import { Grid } from '@material-ui/core'
import React from 'react'

//* utils
import { TopicFaq } from '../../../../models/topics/faq'
import ImgUtil from '../../../../utils/img.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  mtvData: [TopicFaq]
  mainImgPath: string
  mainImgAlt: string
}
export const ColumnLayoutVariant = ({ mtvData, mainImgPath, mainImgAlt }: Props) => {
  return (
    <>
      <WrapperImage
        src={ImgUtil.getResizedImageUrl(mainImgPath, `width=600, height=335`)}
        alt={mainImgAlt}
        threshold={650}
        className="Column-image"
      />

      <Grid container spacing={4} className="Column-entries">
        {mtvData.map((column, index: number) => {
          return (
            <Grid item xs={12} sm={6} key={index}>
              <Typography type="header3">{formatInlineCode(column?.title?.title)}</Typography>
              {column?.body && (
                <Typography type="bodyXL" className="desc">
                  {renderRichText(column?.body)}
                </Typography>
              )}
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}
